module.exports = __webpack_public_path__ + "static/media/calendar-icon.f7797629.svg";